'use strict';

angular.module('app.advertiserCampaignList', [])

.controller('advertiserCampaignListCtrl', ['$scope', '$rootScope', '$http', '$state', '$modal', 'localStorageService', 'commonPagesService', 'TRACK_EVENTS',  function ($scope, $rootScope, $http, $state, $modal, localStorageService, commonPagesService, TRACK_EVENTS) {

    $scope.currentUser = $rootScope.currentUser;
    $scope.campaigns = [];
    $scope.selectedAdvertiser = 0;
    $scope.isFetching = false;
   
    $scope.loadCampaigns = function (selected_company_id) {
        $scope.isFetching = true;
        commonPagesService.getCampaignsByAdvertiserID(selected_company_id, false)
            .then(function (response) {
                $scope.campaigns = response.data;
                $rootScope.campaignsForSelectedAdvertiser = response.data;
                $scope.isFetching = false;
            }, function () {
                $scope.isFetching = true;
                return false;
            })
            .finally(function () {
            });
    };

    if($scope.currentUser.accessibility.leftMenu.showCampaigns == true) {
        $scope.loadCampaigns($scope.selectedAdvertiser);
    }

    $scope.$on('reload_campaignList', function(event, args) {
        if($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
            $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
        }

        $scope.loadCampaigns($scope.selectedAdvertiser);
    });

    $scope.$on('select_campaign', function(event, args) {
        $scope.selectCampaign(args.campaign_id);
    });

    $scope.markCampaign = function (id) {
        $(".kws ul li a").removeClass("active");
        $(".influencers ul li a").removeClass("active");
        $(".preferred ul li").removeClass('activePreferred');

        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
        $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();

        $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
        $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
        $('.main-sidebar .projects .nav-sidebar .project .kws').hide();

        $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');
        $(".campaigns .campaign_" + id).addClass('active');
    }

    $scope.selectCampaign = function (id, name) {
        // Mixpanel tracking influencer group item click
        if (name) {
            var evtItem = TRACK_EVENTS.PAGE_STATE_MAPPING[$state.current.name];
            if (evtItem) {
                analytics.track(
                    TRACK_EVENTS.CLICK_ON_CAMPAIGN.EVT_NAME,
                    {
                        "item": evtItem,
                        "target_type": "Campaign",
                        "target_name": name,
                        "target_id": id
                    }
                );
            }
        }

        $scope.markCampaign(id);

        $rootScope.sideMenuSelections.project = id;
        $rootScope.sideMenuSelections.keyword = null;
        $rootScope.sideMenuSelections.blog = null;
        $rootScope.sideMenuSelections.channel = null;
        $rootScope.sideMenuSelections.influencerGroup = null;
        $rootScope.sideMenuSelectedName = {type: "Campaign", id: id, name: name};

        $rootScope.saveParams = {
            project_id : id? id: 0,
            mention : 0,
            blog_id : 0,
            channel: 0,
            influencerGroup: 0,
            _workaround_group_id: 0
        };

        $rootScope.$broadcast('updatePrintHeader', { printHeader : {
            type: "Campaign",
            name: $(".campaigns .campaign_" + id + " .campaign-name").text()
        }});

        $rootScope.$broadcast('refreshDashboard', {});

        if($state.current.name == "home.influencerOverview" || $state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
            $state.transitionTo("home.dashboard", null, {
                reload: false,
                inherit: false,
                notify: true
            });
        }

        angular.element('#switch-' + id + '-line').addClass('selected');
    }

}]);